import { Component, ElementRef, inject, input, output, signal, viewChild } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { firstValueFrom } from 'rxjs';
import { getRolName, RRol } from '@cumlaude/service-contract';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { RolSwitcherDialogComponent, RolSwitcherDialogData } from '../../dialogs/rol/rol-switcher-dialog/rol-switcher-dialog.component';

@Component({
	selector: 'app-rol-switcher',
	templateUrl: './rol-switcher.component.html',
	styleUrls: ['./rol-switcher.component.scss'],
	imports: [IconComponent],
})
export class RolSwitcherComponent {
	private readonly dialog = inject(Dialog);
	private readonly overlay = inject(Overlay);

	readonly rollen = input.required<RRol[]>();
	readonly activeRol = input.required<RRol | undefined>();
	rolChange = output<RRol>();

	readonly showDropdown = signal(false);

	readonly triggerHost = viewChild.required<ElementRef>('triggerHost');

	protected readonly getRolName = getRolName;

	async openDialog() {
		this.showDropdown.set(true);

		const triggerElement = this.triggerHost().nativeElement;

		const dialogRef = this.dialog.open<RRol, RolSwitcherDialogData>(RolSwitcherDialogComponent, {
			ariaLabel: 'Kies je rol',
			data: {
				rollen: this.rollen(),
				activeRol: this.activeRol(),
			},
			backdropClass: 'cdk-overlay-transparent-backdrop',
			positionStrategy: this.overlay
				.position()
				.flexibleConnectedTo(triggerElement)
				.withFlexibleDimensions(false)
				.withPositions([
					{
						originX: 'start',
						originY: 'bottom',
						overlayX: 'start',
						overlayY: 'top',
						offsetY: 23,
					},
					{
						originX: 'start',
						originY: 'top',
						overlayX: 'start',
						overlayY: 'bottom',
						offsetY: -23,
					},
				]),
		});

		const gekozenRol = await firstValueFrom(dialogRef.closed);
		if (gekozenRol && gekozenRol !== this.activeRol()) this.rolChange.emit(gekozenRol);

		this.showDropdown.set(false);
	}
}
